import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import ThreeDRotationIcon from '@material-ui/icons/ThreeDRotation';
import Fab from '@material-ui/core/Fab';
import Tooltip from '@material-ui/core/Tooltip';

//import useVideoContext from '../../../hooks/useVideoContext/useVideoContext';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    fab: {
      margin: theme.spacing(1),
    },
  })
);

export default function ToursButton({handleClick}: any) {
  const classes = useStyles();

  return (
    <Tooltip title={'View Tours'} placement="top" PopperProps={{ disablePortal: true }}>
      <Fab className={classes.fab} onClick={() => handleClick(1)}>
        <ThreeDRotationIcon />
      </Fab>
    </Tooltip>
  );
}
